import React from "react";
import { useTranslation } from "react-i18next";
import CV from "../../assets/abdulrahman_mobileDeveloper07.pdf";
import { handleDownloadCv } from "../../helpers/index.js";
import PreviewCvModal from "../Auth/PreviewCvModal";
import SocialMedia from "../SocialMedia/index";
const HeaderBio = ({ aboutmeData }) => {
  console.log(aboutmeData);
  const { t, i18n } = useTranslation();
  const [seamore, setSeamore] = React.useState(false);
  const [end, setEnd] = React.useState(4);
  return (
    <div className="header-text ">
      <div className="header-contant">
        <h4>{i18n.language === "en" ? "Hi👋" : "مرحبا 👋"}</h4>
        <h2>
          {i18n.language === "en" ? "I'm" : "أنا"} {aboutmeData.name} 👨‍💻
        </h2>
        <p>
          {aboutmeData.bio?.slice(0, end).map((item) => {
            return (
              <span key={item}>
                {item}
                <br />
              </span>
            );
          })}
          <span
            className="text-warning"
            style={{ fontWeight: "bold", cursor: "pointer" }}
            onClick={() => {
              setSeamore(!seamore);
              setEnd(seamore ? 4 : aboutmeData.bio.length);
            }}
          >
            {seamore ? "See less" : "See more"}
          </span>
        </p>

        <div className="header-buttons d-flex justify-content-start gap-3">
          <button
            className="btn"
            onClick={() =>
              handleDownloadCv(CV, "abdulrahman_Hatem_Ramadan_Resume")
            }
          >
            CV <i class="fa-solid fa-file-arrow-down"></i>
          </button>
          <PreviewCvModal CVLink={aboutmeData.cv} />
        </div>
      </div>

      <div className="header-social">
        <SocialMedia />
      </div>
    </div>
  );
};

export default HeaderBio;
